/**
 * @generated SignedSource<<bba594d06da9b6b86427f12ddccbb576>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SubIssuesList$data = {
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"AddSubIssueButtonGroup">;
  readonly " $fragmentType": "SubIssuesList";
};
export type SubIssuesList$key = {
  readonly " $data"?: SubIssuesList$data;
  readonly " $fragmentSpreads": FragmentRefs<"SubIssuesList">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SubIssuesList",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AddSubIssueButtonGroup"
    }
  ],
  "type": "Issue",
  "abstractKey": null
};

(node as any).hash = "d8c9ffcc4e9e4797aa7575f65efd26a0";

export default node;
